import {Error, ValidationResult, Validator} from '@/type/validation/result';
import {日付書式} from '@/type/validation/validator';
import moment from 'moment';
import {期限切れ破棄破損検索条件型} from '@/type/custom/otaru/destroy/otaruDestroyListSearchCriteria';

export default class 期限切れ破棄破損検索条件チェッカー {
  単項目チェック結果: Error[] = [];
  相関チェック結果: Error[] = [];

  constructor(target: 期限切れ破棄破損検索条件型) {
    const 期限切れ破棄破損検索条件チェック = new ValidationResult(期限切れ破棄破損検索条件Validators);
    期限切れ破棄破損検索条件チェック.validate(target);
    this.単項目チェック結果 = 期限切れ破棄破損検索条件チェック.getErrors;
    this.相関チェック結果 = 相関チェック(target);
  }

  hasErrors(): boolean {
    return this.単項目チェック結果.length > 0 || this.相関チェック結果.length > 0;
  }

  errorMessages(): string[] {
    return this.単項目チェック結果.concat(this.相関チェック結果)
      .map((value) => `${value.message}`);
  }

  hasError(name: string): boolean {
    return this.単項目チェック結果.concat(this.相関チェック結果).some((error) => error.name === name);
  }
}

const 検索開始処理日Validator = {
  name: '検索開始処理日',
  constraints: [
    {method: 日付書式, message: '処理日の書式を正しく入力してください'},
  ],
};

const 検索終了処理日Validator = {
  name: '検索終了処理日',
  constraints: [
    {method: 日付書式, message: '処理日の書式を正しく入力してください'},
  ],
};

const 検索開始登録日Validator = {
  name: '検索開始登録日',
  constraints: [
    {method: 日付書式, message: '登録日の書式を正しく入力してください'},
  ],
};

const 検索終了登録日Validator = {
  name: '検索終了登録日',
  constraints: [
    {method: 日付書式, message: '登録日の書式を正しく入力してください'},
  ],
};

const 期限切れ破棄破損検索条件Validators: Validator[] = [
  検索開始処理日Validator,
  検索終了処理日Validator,
  検索開始登録日Validator,
  検索終了登録日Validator,
];


function 相関チェック(target: 期限切れ破棄破損検索条件型): Error[] {
  const errors: Error[] = [];
  if (moment(target.検索終了処理日).isBefore(moment(target.検索開始処理日))) {
    errors.push({index: 1, message: '処理日の範囲指定が間違っています', constraint: '', name: '処理日期間'});
  }
  if (moment(target.検索終了登録日).isBefore(moment(target.検索開始登録日))) {
    errors.push({index: 1, message: '登録日の範囲指定が間違っています', constraint: '', name: '登録日期間'});
  }
  return errors;
}
